import React from 'react'
import { getFastlyUrl } from '@corratech/pylot-image'

const getFastlyConfig = () => {
    return { width: 782, height: 389, quality: 100 }
}

const applyFastlyToImages = (answerContent) => {
    return answerContent.replace(
        /<img [^>]*src="([^"]*)"[^>]*>/g,
        (match, src) => {
            const fastlyImageUrl = getFastlyUrl({
                src,
                ...getFastlyConfig()
            })
            return match.replace(src, fastlyImageUrl)
        }
    )
}

const getFaqChildrens = (node) => {
    const faqItems = node.querySelectorAll('li[data-content-type="faq-item"]')

    return Array.from(faqItems).map((item, index) => {
        const questionElement = item.querySelector(
            'h3[data-element="question"]'
        )
        const answerElement = item.querySelector(
            'div[data-element="answer"] > div'
        )

        const answerContent = answerElement?.innerHTML?.trim() ?? 'No Answer'
        const processedAnswerContent = applyFastlyToImages(answerContent)

        const TitleComponent = () => (
            <h6 className="main-heading">
                {questionElement
                    ? questionElement.innerText?.trim()
                    : 'No Question'}
            </h6>
        )

        const ContentComponent = () => (
            <div
                dangerouslySetInnerHTML={{
                    __html: processedAnswerContent
                }}
            />
        )

        TitleComponent.displayName = `TitleComponent${index}`
        ContentComponent.displayName = `ContentComponent${index}`

        return {
            id: `faqItem${index + 1}`,
            Title: TitleComponent,
            Content: ContentComponent
        }
    })
}

const configAggregator = (node) => {
    return {
        childrens: getFaqChildrens(node),
        widgetConfiguration: {
            ...Array.from(node.attributes)
                .filter((attr) => attr.name.startsWith('data-w')) // Filter attributes that start with 'data-'
                .reduce((acc, attr) => {
                    const attrNameWithoutData = attr.name.slice(7) // Remove 'data-w-' from the name
                    acc[attrNameWithoutData] = attr.value
                    return acc
                }, {})
        }
    }
}

export default configAggregator
